export default __webpack_public_path__ + "static/media/systemEntranceCercle.9c117e62.svg";